export default __webpack_public_path__ + "static/media/Partner_Currency_Cloud.8b2dc48d.png";